import { useQuery } from 'react-query';

import { useSessionStore } from 'session/useSessionStore';
import { IResponseAPI } from 'models/interfaces/IResponseAPI';
import { IGridXyzBasicInfo } from '../models/interfaces/IGridXyzBasicInfo';
import { axios } from 'configurations/axios';
import { IGridXyz } from '../models/interfaces/IGridXyz';
import { AmplitudeDomain } from '../models/enums/AmplitudeDomain';

export function useGetGridsIntersectingInGeom(geomWkt: string | undefined, geomSrid: number, resultSrid: number, domain: AmplitudeDomain|null) {
    let { apiUrl, jwtToken } = useSessionStore(state => ({
        apiUrl: state.tenantConfiguration?.endpoints.seismic3DGrid,
        jwtToken: state.jwtToken
    }));

    //console.log(useSessionStore(state => state.tenantConfiguration?.endpoints));
    return useQuery<IGridXyzBasicInfo[]>(
        ['GetGrids', geomWkt],
        async () => {
            const response = await axios.post<IResponseAPI<IGridXyzBasicInfo[]>>(
                apiUrl + '/Seismic3DGrids/GetGridsIntersectingInGeom',
                {
                    geomWkt,
                    geomSrid,
                    resultSrid,
                    domain
                },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            return response.data.Result;
        },
        {
            enabled: !!geomWkt && !!domain
        }
    );
}

export const useGetGridByToken = (token: string | undefined, desiredSrid: number, enabled: boolean = true) => {
    let { apiHost, jwt } = useSessionStore(state => ({
        apiHost: state.tenantConfiguration?.endpoints.seismic3DGrid,
        jwt: state.jwtToken
    }));

    return useQuery(
        ['GetGrids', token],
        async () => {
            const response = await axios.get<IResponseAPI<IGridXyz>>(
                apiHost + '/Seismic3DGrids/GetGridByToken',
                {
                    params: {
                        token: token,
                        desiredSrid: desiredSrid
                    },
                    headers: {
                        Authorization: 'Bearer ' + jwt,
                        'Content-Type': 'application/json'
                    }
                }
            );
            return response.data.Result;
        },
        {
            enabled: !!token && !!enabled
        }
    );
};